import { type FetchUserMeAuthenticationMethodsParams } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchUserAuthMethods } from '../api';

/**
 * @params FetchUserMeAuthenticationMethodsParams
 * @returns user authentication methods
 */
export const useUserAuthMethodsQuery = (params?: FetchUserMeAuthenticationMethodsParams) =>
	useQuery({ queryFn: () => fetchUserAuthMethods(params), queryKey: ['fetchUserMeAuthenticationMethods', params] });
